module.exports = __webpack_public_path__ + "media/src/components/EmployerProfile/img/glassdoorHoverIcon-0624fa9fc1c27e1b3ffc823e12884c3e.svg";